
import { useState, useEffect } from 'react';
import { useGlobalStore } from '@/hooks';

/**
 * 用于检测用户的设备类型：PC 或移动设备
 * @returns 包含 isPc 和 isMobile 两个布尔值的对象
 */
const useDeviceType = () => {

  const __DEMARCATION_WIDTH = '(max-width: 768px)';

  const matchMediaPolyfill = (): any => {
    return (mediaQuery: string) => {
      return {
        addListener: () => { },
        removeListener: () => { },
        matches: mediaQuery === __DEMARCATION_WIDTH
      };
    };
  };

  const { appConfig } = useGlobalStore();

  const [isPc, setIsPc] = useState<boolean>(appConfig.deviceType === 'Pc');

  useEffect(() => {
    // @ts-ignore
    let matchMedia: ((query: string) => MediaQueryList) | null = null;
    if (typeof window !== "undefined") {
      matchMedia = window.matchMedia;
    }
    if (matchMedia) {
      if (typeof matchMedia(__DEMARCATION_WIDTH) === 'undefined') {
        matchMedia = matchMediaPolyfill();
      }
      const mq: any = matchMedia?.(__DEMARCATION_WIDTH) || null;
      if (isPc !== (!mq.matches)) {
        setIsPc(!mq.matches);
      }
      const handleOrientationChange = (event: MediaQueryListEvent) => {
        setIsPc(!event.matches);
      };
      mq.addListener(handleOrientationChange);
      return () => {
        mq.removeListener(handleOrientationChange);
      };
    }
  }, []);

  // 判断当前宽度是否小于传入值
  const isWidthLessThan = (width: number): boolean => {
    if (typeof window !== "undefined") {
      return window?.innerWidth <= width
    } else {
      return false
    }
  };

  return { isPc, isMobile: !isPc, isWidthLessThan };   

};

export default useDeviceType;

